import moment from 'moment/moment';
import React, {useEffect, useState} from 'react';
import {
   FlatList,
   Image,
   ImageBackground,
   StyleSheet,
   Text,
   TouchableOpacity,
   View,
   ActivityIndicator,
   NativeModules,
   Platform,
   Dimensions,
   Alert,
   PermissionsAndroid,
} from 'react-native';
import {
   appBackground,
   AUTHDATA,
   gray,
   primaryColor500,
   primaryColor900,
   white,
   FONT_FAMILY_MEDIUM,
   FONT_FAMILY_REGULAR,
   BASE_URL,
   redirectToBrowser,
   MYTRAINING,
   DASHBOARD,
   PROFILE,
   BROUS,
   isNewAPI,
   getNorcatId,
   getQRCode,
   appBackgroundWhiteBG,
   primaryColor800,
   isWindows,
   isMobile,
   ActivityLoaderColor,
   BUTTON_HOVER_COLOR,
   isHoverEnabled,
   BACK_BUTTON_HOVER_COLOR,
   alertHandler,
   isMacOS,
} from '../../utils/utils';
import {retrieveAppData} from '../../utils/preference';
import {ApplicationHeader} from '../../utils/application_header';
import {useIsFocused, useNavigation} from '@react-navigation/native';
import {useSelector, useDispatch} from 'react-redux';
import {
   selectScreenOrientation,
   selectLandscapeSmallWebView,
} from '../../redux/slices/ScreenOrientationSlice';
import Landscap_Application_Header from '../../utils/Landscap_Application_Header';
import DashboardHeaderLandsacap from '../dashboard/DashboardHeaderLandsacap';
import DashboardRightPanel from '../dashboard/DashboardRightPanel';
import ModuleItems from './ModuleItems';
import {selectUserRecord} from '../../redux/slices/UserRecordSlice';
import UICircularProgress from '../../components/circular-progress';
import logger from '../../utils/logger';
import api, {
   apiPostRequest2,
   showTokenExpireAlertWeb,
} from '../../service/network_access';
import {selectAuthData, setSignIn} from '../../redux/slices/AuthSlice';
const {Buffer} = require('buffer');
import UISvg from '../../components/svg';
import CustomAlert from '../../components/custom-alert/index.web';
import {setIsTrPageReload} from '../../redux/slices/MyTrainingRecordSlice';
import TabView from '../dashboard/TabView';
import DocumentItems from './DocumentItems';
import {setResponseAlertData} from '../../redux/slices/ResponseAlertSlice';
//import {Linking} from 'react-native-windows';
import RNFS from '../../components/fs';
import Share from '../../components/share';
import {ContainerWrapper} from '../../components/common';

const isWeb = Platform.OS === 'web';
const TRAINING = 'training';
const DOCUMENT = 'document';
const RecordDetailsScreen = () => {
   const navigation = useNavigation();
   const isLandscapemode = useSelector(selectScreenOrientation);
   const [authData, setAuthData] = useState({});
   const [listType, setListType] = useState(TRAINING);
   const module = useSelector(selectUserRecord);
   const isScreenFocused = useIsFocused();

   const isPrintCertificate =
      (module.CurrentStatus === '2 -COM' ||
         module.CurrentStatus === '3 -C60' ||
         module.CurrentStatus === '4 -C30' ||
         module.CurrentStatus === '5 -EXP' ||
         module.CurrentStatus === '6 -HIS') &&
      listType === TRAINING;
   const moduleList = isNewAPI
      ? module.UserTrainingModuleRecordList === undefined
         ? []
         : module.UserTrainingModuleRecordList
      : module.moduleRecord;

   const documentList = isNewAPI
      ? module.DocumentRecords === undefined
         ? []
         : module.DocumentRecords
      : module.moduleRecord;
   const authNewData = useSelector(selectAuthData);
   const [isDownloadApiLoading, setDownloadIsApiLoading] = useState(false);
   const isMacos = Platform.OS === 'macos';
   const [showAlertData, setShowAlertData] = useState({
      showAlert: false,
      title: 'Alert!',
      message: '',
      callback: null,
   });
   const dispatch = useDispatch();
   const isLandscapeSmallWebView = useSelector(selectLandscapeSmallWebView);
   //const isWindows = Platform.OS === 'windows';
   const userAgent = isWeb ? window.navigator.userAgent : null;
   const windowsBrowser = userAgent?.includes('Windows');
   const windowHeight = isWeb
      ? window.innerHeight
      : Dimensions.get('window').height;
   const advtsHeight =
      windowHeight < 780
         ? // Medium size Desktop/Tablet
           windowHeight < 680
            ? windowHeight < 600
               ? windowHeight * 0.56
               : windowHeight * 0.625
            : windowHeight < 701
            ? windowHeight * 0.64
            : windowHeight < 750
            ? windowHeight * 0.675
            : windowHeight * 0.65
         : // Large size Desktop
         windowHeight > 1000
         ? windowHeight * 0.75
         : windowHeight * 0.7;
   const [modulePercentage, setModulePercentage] = useState(0);
   const [backHover, setBackHover] = React.useState(false);
   const [certificateHover, setCertificateHover] = React.useState(false);
   const [recordHover, setRecordHover] = React.useState(false);
   useEffect(() => {
      if ((isWindows && isScreenFocused) || !isWindows) {
         setListType(module.CourseType === 'IBT' ? TRAINING : DOCUMENT);

         (async () => {
            const authData = await retrieveAppData(AUTHDATA);
            const data = JSON.parse(authData);
            setAuthData(data);
            getModulePercentage();
         })();
      }
   }, []);

   function getModulePercentage() {
      const moduleList = isNewAPI
         ? module.UserTrainingModuleRecordList === undefined
            ? []
            : module.UserTrainingModuleRecordList
         : module.moduleRecord;
      setModulePercentage(parseInt(overPercent(moduleList)));
   }

   function GetRecordFile(record) {
      const downloadRecord =
         BASE_URL +
         'GetDocument?theData=%7B%22EmployeeKey%22%3A%22' +
         authData.ACMEmployeeKey +
         '%22%2C%22RecordKey%22%3A%22' +
         record.key +
         '%22%7D';
      redirectToBrowser({url: downloadRecord});
   }
   async function apiPostRequest_({url, parms}) {
      logger(`URL:: ${url}`);
      logger(`PARAMS: ${JSON.stringify(parms)}`);
      // logger('API_headers::', api.defaults.headers);
      const response = await api
         .post(url, parms, {responseType: 'arraybuffer'})
         .then(res => {
            const responseData = JSON.stringify(res.data);
            return res.data;
         })
         .catch(e => {
            return 'Kindly check your network connection.';
         });
      return response;
   }
   function downloadRecordFile(uri, key, fileName) {
      setDownloadIsApiLoading(true);
      (async () => {
         const reqParms = {
            theData: JSON.stringify({
               EmployeeKey: authNewData.EmployeeKey,
               RecordKey: key,
            }),
         };
         const callApi = isWeb
            ? apiPostRequest2({
                 url: uri,
                 parms: reqParms,
                 responseType: 'arraybuffer',
              })
            : apiPostRequest_({
                 url: uri,
                 parms: reqParms,
                 responseType: 'arraybuffer',
              });
         callApi
            .then(res => {
               if (
                  res !== null &&
                  res !== undefined &&
                  typeof res !== 'string'
               ) {
                  if (res.response?.status === 401 && Platform.OS === 'web') {
                     setDownloadIsApiLoading(false);
                     setShowAlertData({
                        showAlert: true,
                        title: 'Alert!',
                        message:
                           'Your session has expired. Please login again to proceed.',
                        callback: () => {
                           const user = {
                              isLoggedIn: false,
                              userName: '',
                           };
                           dispatch(setSignIn(user));
                        },
                     });
                  } else {
                     setDownloadIsApiLoading(false);
                     const pdfData = res; // Byte array data of the PDF // Open the PDF in WebView
                     logger('============================================');
                     logger(res);
                     if (res.length === 0 && Object.keys(res).length === 0) {
                        //alert('File Not Found');
                        alertHandler(
                           dispatch,
                           setResponseAlertData,
                           'File Not Found.',
                           'NO_BACK',
                        );
                     } else {
                        if (!isMacos) {
                           // alert(pdfData);

                           const data = `${Buffer.from(pdfData).toString(
                              'base64',
                           )}`;
                           downloadAndSaveFile(pdfData, fileName, pdfData);
                        } else {
                           const data = `${Buffer.from(pdfData).toString(
                              'base64',
                           )}`;
                           NativeModules.WebviewModule.saveFileInDownloads(
                              data,
                              getFileNameWithMiliSec(fileName),
                           );
                        }
                     }
                  }
               } else {
                  if (isWeb) {
                     showTokenExpireAlertWeb(res);
                  } else {
                     alert(res);
                  }
               }
            })
            .catch(error => {
               logger('error::', error);
            });
      })();
   }
   function downloadRecord(uri) {
      setDownloadIsApiLoading(true);
      (async () => {
         const reqParms = {
            theData: JSON.stringify({
               EmployeeKey: authNewData.EmployeeKey,
               UserKey: module.UserKey,
            }),
         };
         const callApi = isWeb
            ? apiPostRequest2({
                 url: uri,
                 parms: reqParms,
                 responseType: 'arraybuffer',
              })
            : apiPostRequest_({
                 url: uri,
                 parms: reqParms,
                 responseType: 'arraybuffer',
              });
         callApi
            .then(res => {
               if (
                  res !== null &&
                  res !== undefined &&
                  typeof res !== 'string'
               ) {
                  if (res.response?.status === 401 && Platform.OS === 'web') {
                     setDownloadIsApiLoading(false);
                     const user = {
                        isLoggedIn: false,
                        userName: '',
                     };
                     dispatch(setSignIn(user));
                     dispatch(
                        setResponseAlertData({
                           showAlert: true,
                           title: 'Alert!',
                           message:
                              'Your session has expired. Please login again to proceed.',
                           callbackType: 'TOKEN_EXPIRED',
                        }),
                     );
                  } else {
                     setDownloadIsApiLoading(false);
                     const pdfData = res; // Byte array data of the PDF // Open the PDF in WebView
                     logger('============================================');
                     if (!isMacos) {
                        navigation.navigate('WebViewContainer', {
                           urlPath: `data:application/pdf;base64,${Buffer.from(
                              pdfData,
                           ).toString('base64')}`,
                           isShowingByBase64Str: true,
                           sharingEnabled: true,
                           apiAction: uri,
                           title:
                              uri === 'PrintReportCard'
                                 ? 'Download Record'
                                 : 'Download Certificate',
                        });
                     } else {
                        const data = `${Buffer.from(pdfData).toString(
                           'base64',
                        )}`;
                        NativeModules.WebviewModule.openPDFInWebView(data, uri);
                     }
                  }
               } else {
                  if (isWeb) {
                     showTokenExpireAlertWeb(res);
                  } else {
                     alert(res);
                  }
               }
            })
            .catch(error => {
               logger('error::', error);
            });
      })();
   }

   const renderActivityIndicator = () => {
      if (isDownloadApiLoading) {
         return (
            <View
               style={{
                  width: '100%',
                  height: '100%',
                  justifyContent: 'center',
                  alignItems: 'center',
                  position: 'absolute',
               }}>
               <ActivityIndicator
                  size="large"
                  color={ActivityLoaderColor}
                  style={{
                     position: 'absolute',
                     top: 0,
                     bottom: 0,
                     left: 0,
                     right: 0,
                     zIndex: 1,
                  }}
               />
            </View>
         );
      }
      return null;
   };

   const requestStoragePermission = async () => {
      try {
         const granted = await PermissionsAndroid.request(
            PermissionsAndroid.PERMISSIONS.WRITE_EXTERNAL_STORAGE,
            {
               title: 'Storage Permission',
               message:
                  'App needs access to your storage to download the file.',
               buttonPositive: 'OK',
               buttonNegative: 'Cancel',
            },
         );
         return granted === PermissionsAndroid.RESULTS.GRANTED;
      } catch (error) {
         console.error('Error requesting storage permission:', error);
         return false;
      }
   };

   const downloadAndSaveFile = async (base64Data, fileName, bytesArray) => {
      if (Platform.OS === 'web') {
         const name = fileName;
         const userAgent = window.navigator.userAgent;
         // Create a Blob from the Uint8Array
         const blob = new Blob([bytesArray], {
            type: 'application/octet-stream',
         });
         // Generate a temporary URL for the Blob
         const url = URL.createObjectURL(blob);
         // Create a link element
         const link = document.createElement('a');
         // Set the href attribute of the link to the temporary URL
         link.href = url;
         // Set the download attribute to the desired file name
         link.download = fileName; // Change the file name as needed
         // Append the link to the document
         document.body.appendChild(link);
         // Trigger a click on the link to start the download
         link.click();
         // Remove the link from the document
         document.body.removeChild(link);
         // Revoke the temporary URL to free up resources
         URL.revokeObjectURL(url);
      } else {
         // To do on other platforms

         const name = getFileNameWithMiliSec(fileName);
         if (Platform.OS === 'android') {
            const granted = await requestStoragePermission();
            if (!granted) {
               console.warn('Storage permission denied.');
               return;
            }
         }
         const data = `${Buffer.from(bytesArray).toString('base64')}`;
         var path;
         if (Platform.OS === 'ios') {
            path = `${RNFS.DocumentDirectoryPath}/${name}`;
         } else if (Platform.OS === 'android') {
            path = `${RNFS.DownloadDirectoryPath}/${name}`;
         } else {
            path = `${RNFS.DownloadDirectoryPath}/${name}`;
         }
         try {
            await RNFS.writeFile(path, data, 'base64');
            // Share the PDF file using react-native-share
            if (isWindows) {
               alert('Download Complete');
            } else {
               Share.open({
                  url: `file://${path}`,
               })
                  .then(() => {
                     logger('PDF shared successfully');
                  })
                  .catch(error => {
                     logger('Error sharing PDF:', error);
                  });
            }
         } catch (error) {
            if (Platform.OS === 'windows') {
               alert(
                  'Allowing access to your file system. \nIn Windows 10, go to Start  > Settings  > Privacy > File system \nIn Windows 11, go to Start  > Settings  > Privacy & security > File system.',
                  [
                     {
                        text: 'OK',
                        onPress: () => logger('OK Pressed'),
                     },
                  ],
                  {cancelable: false},
               );
            } else {
               console.error('Error saving file:', error);
            }
         }
      }
   };

   function getFileNameWithMiliSec(fileName) {
      const splitName = fileName.split('.');
      // Get the file name and extension from the resulting array
      var name = splitName[0];
      const extension = splitName[1];
      const d = new Date();
      let ms = d.getMilliseconds();
      return name + ms + '.' + extension;
   }

   return (
      <View
         style={[
            styles.container,
            {
               ...Platform.select({
                  web: {
                     flex: null,
                     height: !isLandscapemode
                        ? isLandscapeSmallWebView
                           ? '100%'
                           : '100vh'
                        : '100vh',
                     minHeight: isLandscapeSmallWebView ? '100vh' : null,
                     overflowY: isLandscapemode ? 'hidden' : 'auto',
                  },
               }),
            },
         ]}>
         {!isLandscapemode ? (
            <ApplicationHeader
               OnBackPress={() => {
                  navigation.goBack();
               }}
               title="Record Details"
            />
         ) : (
            <Landscap_Application_Header
               authData={authData}
               isProfileScreen={true}
               onProfileClick={() => {
                  navigation.navigate('ProfileScreen');
               }}
               selectedTab={MYTRAINING}
               onTopMenuClick={value => {
                  if (value === DASHBOARD) {
                     navigation.navigate('DashboardScreen');
                  } else if (value === MYTRAINING) {
                     navigation.navigate('MyTraningScreen');
                  } else if (value === PROFILE) {
                     navigation.navigate('ProfileScreen');
                  } else if (value === BROUS) {
                     navigation.navigate('BrowsesCoursesScreen');
                  }
               }}
               dataSource={['View Profile', 'Edit Profile', 'Logout']}
            />
         )}
         {!isLandscapemode ? (
            <View style={{flex: 1}}>
               <DetailView
                  module={module}
                  listType={listType}
                  setListType={type => {
                     setListType(type);
                  }}
               />
               {(listType === TRAINING &&
                  (moduleList === null || moduleList?.length === 0)) ||
               (listType === DOCUMENT &&
                  (documentList === null || documentList?.length === 0)) ? (
                  <View style={{flex: 1, justifyContent: 'center'}}>
                     <Text
                        style={{
                           color: '#000000',
                           // height: '100%',
                           alignSelf: 'center',
                           justifyContent: 'center',
                           alignItems: 'center',
                           textAlignVertical: 'center',
                           alignContent: 'center',
                        }}>
                        {listType === TRAINING
                           ? 'NO MODULE DATA AVAILABLE'
                           : 'NO DOCUMENT DATA AVAILABLE'}
                     </Text>
                  </View>
               ) : (
                  <View style={{flex: 1, marginBottom: 10}}>
                     <RecordList
                        listType={listType}
                        myTraningList={
                           listType === TRAINING ? moduleList : documentList
                        }
                        isprintRecord={isPrintCertificate}
                        onDownloadPress={downloadRecordFile}
                        loading={isDownloadApiLoading}
                     />
                  </View>
               )}
               {isPrintCertificate ? (
                  <View
                     style={
                        !isLandscapemode && {
                           ...Platform.select({
                              web: {
                                 position: 'fixed',
                                 bottom: 0,
                                 left: 0,
                                 right: 0,
                                 marginBottom: 4,
                              },
                              ios: {
                                 bottom: 10,
                                 left: 0,
                                 right: 0,
                              },
                           }),
                        }
                     }>
                     <TouchableOpacity
                        style={{
                           backgroundColor: recordHover
                              ? BUTTON_HOVER_COLOR
                              : primaryColor500,
                           minHeight: 48,
                           borderRadius: 6,
                           marginBottom: 5,
                           marginHorizontal: 12,
                           justifyContent: 'center',
                        }}
                        onMouseEnter={() => {
                           setRecordHover(true);
                        }}
                        onMouseLeave={() => {
                           setRecordHover(false);
                        }}
                        onPress={() => {
                           if (isNewAPI) {
                              downloadRecord('PrintReportCard');
                           } else {
                              GetRecordFile(module);
                           }
                        }}>
                        <View
                           style={{
                              flexDirection: 'row',
                              justifyContent: 'center',
                              alignContent: 'center',
                              alignItems: 'center',
                           }}>
                           <Text
                              style={{
                                 color: 'white',
                                 fontSize: 16,
                                 fontWeight: '500',
                                 textAlign: 'center',
                                 fontFamily: FONT_FAMILY_MEDIUM,
                              }}>
                              Download Record
                           </Text>
                           <Image
                              source={require('../../assets/downloadIcon-black.png')}
                              style={{
                                 marginStart: 10,
                                 tintColor: 'white',
                                 width: 18,
                                 height: 18,
                              }}
                           />
                        </View>
                     </TouchableOpacity>

                     {isNewAPI && (
                        <TouchableOpacity
                           style={{
                              backgroundColor: certificateHover
                                 ? BUTTON_HOVER_COLOR
                                 : primaryColor500,
                              minHeight: 48,
                              borderRadius: 6,
                              marginBottom: 12,
                              marginHorizontal: 12,
                              justifyContent: 'center',
                           }}
                           onMouseEnter={() => {
                              setCertificateHover(true);
                           }}
                           onMouseLeave={() => {
                              setCertificateHover(false);
                           }}
                           onPress={() => {
                              downloadRecord('PrintCertificate');
                           }}>
                           <View
                              style={{
                                 flexDirection: 'row',
                                 justifyContent: 'center',
                                 alignContent: 'center',
                                 alignItems: 'center',
                              }}>
                              <Text
                                 style={{
                                    color: 'white',
                                    fontSize: 16,
                                    fontWeight: '500',
                                    textAlign: 'center',
                                    fontFamily: FONT_FAMILY_MEDIUM,
                                 }}>
                                 Download Certificate
                              </Text>
                              <Image
                                 source={require('../../assets/downloadIcon-black.png')}
                                 style={{
                                    marginStart: 10,
                                    tintColor: 'white',
                                    width: 18,
                                    height: 18,
                                 }}
                              />
                           </View>
                        </TouchableOpacity>
                     )}
                  </View>
               ) : null}
            </View>
         ) : (
            <View
               style={{
                  flexDirection: 'row',
                  flex: 1,
               }}>
               <View
                  style={{
                     flex: 1,
                     paddingBottom: isWindows ? (!isMobile ? 14 : null) : null,
                  }}>
                  <DashboardHeaderLandsacap
                     subtitle={authData.CompanyName}
                     icon={require('../../assets/my_training.png')}
                     title="Record Details"
                     showCourses={true}
                     trainigRecords={moduleList?.length}
                     showSearchView={isWeb ? false : false}
                     showFilterTabs={false}
                     showRecordTabs={false}
                     showFooter={false}
                     isRecordScreen={true}
                     showRefreshIcon={false}
                     onFilterClick={filterRef => {
                        // filterList(filterRef);
                     }}
                     onSearch={text => {}}
                     authData={authData}
                  />
                  <DetailView
                     module={module}
                     listType={listType}
                     setListType={type => {
                        setListType(type);
                     }}
                  />
                  {(listType === TRAINING &&
                     (moduleList === null || moduleList?.length === 0)) ||
                  (listType === DOCUMENT &&
                     (documentList === null || documentList?.length === 0)) ? (
                     <View style={{flex: 1, justifyContent: 'center'}}>
                        <Text
                           style={{
                              color: '#000000',
                              // height: '100%',
                              alignSelf: 'center',
                              justifyContent: 'center',
                              alignItems: 'center',
                              textAlignVertical: 'center',
                              alignContent: 'center',
                           }}>
                           {listType === TRAINING
                              ? 'NO MODULE DATA AVAILABLE'
                              : 'NO DOCUMENT DATA AVAILABLE'}
                        </Text>
                     </View>
                  ) : (
                     <View style={{flex: 1}}>
                        <RecordList
                           listType={listType}
                           myTraningList={
                              listType === TRAINING ? moduleList : documentList
                           }
                           isprintRecord={isPrintCertificate}
                           onDownloadPress={downloadRecordFile}
                           loading={isDownloadApiLoading}
                        />
                     </View>
                  )}
                  <View
                     style={{
                        flexDirection: 'row-reverse',
                        paddingBottom: !isWindows ? 14 : null,
                        ...Platform.select({
                           web: {
                              alignItems: isLandscapemode ? 'flex-end' : null,
                              position: 'absolute',
                              bottom: 0,
                              left: 10,
                              right: windowsBrowser ? 28 : 10,
                              paddingTop: isLandscapemode ? 14 : null,
                              backgroundColor: isLandscapemode
                                 ? appBackgroundWhiteBG
                                 : null,
                           },
                        }),
                     }}>
                     {isPrintCertificate ? (
                        <View
                           style={{
                              flexDirection: 'row',
                           }}>
                           {isNewAPI && (
                              <TouchableOpacity
                                 style={{
                                    backgroundColor: certificateHover
                                       ? BUTTON_HOVER_COLOR
                                       : primaryColor500,
                                    minHeight: 48,
                                    paddingHorizontal: 16,
                                    borderRadius: 6,
                                    justifyContent: 'center',
                                    marginEnd: 16,
                                 }}
                                 onMouseEnter={() => {
                                    setCertificateHover(true);
                                 }}
                                 onMouseLeave={() => {
                                    setCertificateHover(false);
                                 }}
                                 onPress={() => {
                                    downloadRecord('PrintCertificate');
                                 }}>
                                 <View
                                    style={{
                                       flexDirection: 'row',
                                       justifyContent: 'center',
                                       alignContent: 'center',
                                       alignItems: 'center',
                                    }}>
                                    <Text
                                       style={{
                                          color: 'white',
                                          fontSize: 16,
                                          fontWeight: '500',
                                          textAlign: 'center',
                                          fontFamily: FONT_FAMILY_MEDIUM,
                                          ...Platform.select({
                                             web: {
                                                marginBottom: 3,
                                             },
                                          }),
                                       }}>
                                       Download Certificate
                                    </Text>
                                    <Image
                                       source={require('../../assets/downloadIcon-black.png')}
                                       style={{
                                          marginStart: 10,
                                          tintColor: 'white',
                                          width: 18,
                                          height: 18,
                                       }}
                                    />
                                 </View>
                              </TouchableOpacity>
                           )}
                           <TouchableOpacity
                              style={{
                                 backgroundColor: recordHover
                                    ? BUTTON_HOVER_COLOR
                                    : primaryColor500,
                                 minHeight: 48,
                                 paddingHorizontal: 16,
                                 borderRadius: 6,
                                 justifyContent: 'center',
                                 marginEnd: !isWeb ? 10 : null,
                              }}
                              onMouseEnter={() => {
                                 setRecordHover(true);
                              }}
                              onMouseLeave={() => {
                                 setRecordHover(false);
                              }}
                              onPress={() => {
                                 if (isNewAPI) {
                                    downloadRecord('PrintReportCard');
                                 } else {
                                    GetRecordFile(module);
                                 }
                              }}>
                              <View
                                 style={{
                                    flexDirection: 'row',
                                    justifyContent: 'center',
                                    alignContent: 'center',
                                    alignItems: 'center',
                                 }}>
                                 <Text
                                    style={{
                                       color: 'white',
                                       fontSize: 16,
                                       fontWeight: '500',
                                       textAlign: 'center',
                                       fontFamily: FONT_FAMILY_MEDIUM,
                                       ...Platform.select({
                                          web: {
                                             marginBottom: 3,
                                          },
                                       }),
                                    }}>
                                    Download Record
                                 </Text>
                                 <Image
                                    source={require('../../assets/downloadIcon-black.png')}
                                    style={{
                                       marginStart: 10,
                                       tintColor: 'white',
                                       width: 18,
                                       height: 18,
                                    }}
                                 />
                              </View>
                           </TouchableOpacity>
                        </View>
                     ) : null}

                     <TouchableOpacity
                        style={{
                           backgroundColor:
                              isHoverEnabled && backHover
                                 ? BACK_BUTTON_HOVER_COLOR
                                 : white,
                           minHeight: 48,
                           paddingHorizontal: 16,
                           borderRadius: 6,
                           borderColor: primaryColor500,
                           borderWidth: 1,
                           justifyContent: 'center',
                           marginEnd: 16,
                        }}
                        onMouseEnter={() => {
                           setBackHover(true);
                        }}
                        onMouseLeave={() => {
                           setBackHover(false);
                        }}
                        onPress={() => {
                           if (isWindows) {
                              dispatch(setIsTrPageReload(false));
                           }
                           navigation.goBack();
                        }}>
                        <View
                           style={{
                              flexDirection: 'row',
                              justifyContent: 'center',
                              alignContent: 'center',
                              alignItems: 'center',
                           }}>
                           <Image
                              source={require('../../assets/back.png')}
                              style={{
                                 marginEnd: 10,
                                 width: 18,
                                 height: 18,
                                 ...Platform.select({
                                    web: {
                                       width: 14,
                                       height: 14,
                                    },
                                 }),
                              }}
                           />
                           <Text
                              style={{
                                 color: primaryColor500,
                                 fontSize: 16,
                                 fontWeight: '500',
                                 textAlign: 'center',
                                 fontFamily: FONT_FAMILY_MEDIUM,
                                 ...Platform.select({
                                    web: {
                                       marginBottom: 3,
                                    },
                                 }),
                              }}>
                              Back
                           </Text>
                        </View>
                     </TouchableOpacity>
                  </View>
               </View>
               <View
                  style={{
                     flex: 0.4,
                     ...Platform.select({
                        web: {
                           flex: isLandscapemode ? null : 0.4,
                           width: isLandscapemode ? '30%' : null,
                           height: isLandscapemode ? '90vh' : null,
                        },
                     }),
                  }}>
                  <DashboardRightPanel
                     showProgressView={false}
                     showName={true}
                     authData={authData}
                     height={advtsHeight}
                     // maxHeight="73%"
                     onQrClick={() => {
                        navigation.navigate('QRAndBarcodeScreen', {
                           norcatID: getNorcatId(authData),
                           qrID: getQRCode(authData),
                        });
                     }}
                  />
               </View>
            </View>
         )}
         {showAlertData?.showAlert && (
            <CustomAlert
               title={showAlertData.title}
               message={showAlertData.message}
               onOK={showAlertData.callback}
            />
         )}
      </View>
   );
};

const DetailView = props => {
   const moduleList = isNewAPI
      ? props.module.UserTrainingModuleRecordList === undefined
         ? []
         : props.module.UserTrainingModuleRecordList
      : props.module.moduleRecord;
   const isLandscapemode = useSelector(selectScreenOrientation);
   const headerTitle =
      props.listType === TRAINING
         ? 'Viewing Training Record'
         : props.module.DocumentRecords.length > 1
         ? 'Viewing Documents'
         : 'Viewing Document';
   const buttonTitle =
      props.module.DocumentRecords.length > 1 ? 'Documents' : 'Document';
   return (
      <View>
         <View
            style={[
               styles.headerTopBackground,
               {
                  ...Platform.select({
                     web: {
                        background:
                           'linear-gradient(to bottom, #001231 0%, #003da5 100%)',
                     },
                  }),
               },
            ]}>
            {!isWeb && (
               <UISvg
                  height={isWeb ? '100%' : '100%'}
                  width={isWeb ? '100%' : '200%'}
                  x1="0%"
                  y1="100%"
                  x2="0%"
                  y2="0%"
                  offset={['0%', '100%']}
                  stopOpacity={['0', '1']}
                  stopColor={['#003DA500', '#001231']}
                  rectWidth={'100%'}
                  rectHeight={isMacOS ? 150 : '100%'}
               />
            )}
            <View
               style={{
                  flexDirection: 'row',
                  flex: 1,
                  alignItems: 'center',
               }}>
               <UICircularProgress
                  size={78}
                  width={8}
                  bgOpacity={1}
                  percentFont={12}
                  fontWeight={'700'}
                  fill={
                     props.module.CourseType === 'IBT'
                        ? parseInt(overPercent(moduleList))
                        : 100
                  }
                  rotation={0}
                  tintColor="#26E555"
                  onAnimationComplete={() => logger('onAnimationComplete')}
                  backgroundColor={primaryColor800}
                  trailStroke={isWeb ? '#075ae8' : '#003DA5'}
                  imgWidth={24}
                  imgHeight={26}
                  iconBottomMargin={4}
                  iconTopMargin={0}
               />
               <View
                  style={{
                     flex: 1,
                     flexDirection: 'column',
                     marginLeft: 12,
                  }}>
                  <Text
                     style={{
                        color: white,
                        fontSize: 10,
                        fontWeight: '700',
                        fontFamily: FONT_FAMILY_REGULAR,
                        opacity: 0.6,
                     }}>
                     {moduleList === null
                        ? 0 + '  Available Modules'
                        : moduleList?.length + '  Available Modules'}
                  </Text>
                  <Text
                     numberOfLines={5}
                     style={{
                        color: white,
                        fontSize: 16,
                        fontWeight: '700',
                        fontFamily: FONT_FAMILY_REGULAR,
                        marginTop: 4,
                     }}>
                     {isNewAPI
                        ? props.module.CourseName
                        : props.module.coursename}
                  </Text>
                  <Text
                     style={{
                        color: white,
                        fontSize: 10,
                        fontWeight: '700',
                        fontFamily: FONT_FAMILY_REGULAR,
                        marginTop: 8,
                        opacity: 0.6,
                     }}>
                     Valid Until
                  </Text>
                  <Text
                     style={{
                        color: white,
                        fontSize: 12,
                        fontWeight: '700',
                        marginTop: 4,
                        fontFamily: FONT_FAMILY_REGULAR,
                     }}>
                     {props.module.ExpiryDate !== 'n/a'
                        ? moment(props.module.ExpiryDate).format(
                             'MMMM DD, YYYY',
                          )
                        : 'No Expiry'}
                  </Text>
               </View>
            </View>
         </View>
         {props.module.CourseType === 'IBT' &&
            props.module.DocumentRecords.length !== 0 && (
               <View
                  style={[
                     styles.headerBottomBackground,
                     {
                        paddingEnd:
                           Platform.OS === 'web' && isLandscapemode ? 20 : 6,
                     },
                     {
                        height:
                           Platform.OS == 'web'
                              ? 48
                              : isLandscapemode
                              ? 48
                              : 32,
                     },
                  ]}>
                  <Text
                     style={{
                        flex: 1,
                        color: '#6E8EFF',
                        fontSize: 12,
                        fontWeight: '600',
                        fontFamily: FONT_FAMILY_REGULAR,
                     }}>
                     {headerTitle}
                  </Text>
                  <View style={{flexDirection: 'row'}}>
                     <TouchableOpacity
                        onPress={() => {
                           props.setListType(TRAINING);
                        }}>
                        <TabView
                           isSelected={
                              props.listType === TRAINING ? true : false
                           }
                           value="Score"
                        />
                     </TouchableOpacity>
                     <TouchableOpacity
                        onPress={() => {
                           props.setListType(DOCUMENT);
                        }}>
                        <TabView
                           isSelected={
                              props.listType === DOCUMENT ? true : false
                           }
                           value={buttonTitle}
                        />
                     </TouchableOpacity>
                  </View>
               </View>
            )}

         <View
            style={[
               styles.headerBottomBackground2,
               {minHeight: isLandscapemode ? 40 : 24},
            ]}>
            <Text
               style={{
                  flex: 1,
                  color: gray,
                  fontSize: 10,
                  fontWeight: '600',
                  fontFamily: FONT_FAMILY_REGULAR,
               }}>
               {props.listType === TRAINING ? 'Module Name' : 'Document Name'}
            </Text>
            <View
               style={{
                  height: 12,
                  width: 2,
                  marginRight: 12,
                  backgroundColor: white,
                  opacity: 0.2,
               }}
            />
            <Text
               style={{
                  color: gray,
                  fontSize: 10,
                  marginRight: isLandscapemode ? 16 : 0,
                  fontWeight: '600',
                  fontFamily: FONT_FAMILY_REGULAR,
               }}>
               {props.listType === TRAINING ? 'Module Score' : 'Download'}
            </Text>
         </View>
      </View>
   );
};

function overPercent(moduleRecord) {
   if (moduleRecord === null || moduleRecord?.length === 0) {
      return 0;
   }
   if (isNewAPI) {
      var sum = moduleRecord.reduce((a, c) => {
         return a + c.TestQuestionScore;
      }, 0);
      return sum / moduleRecord?.length;
   } else {
      var sum = moduleRecord.reduce((a, c) => {
         return a + c.TestResult;
      }, 0);
      return sum / moduleRecord?.length;
   }
}

const RecordList = props => {
   const isLandscapeSmallWebView = useSelector(selectLandscapeSmallWebView);
   const isLandscapemode = useSelector(selectScreenOrientation);
   const isbuttonVisible = props.isprintRecord;
   return (
      <ContainerWrapper {...props}>
         <View
            style={{
               flex: 1,
               marginTop: 12,
               marginBottom: 10,
               ...Platform.select({
                  web: {
                     marginBottom: isLandscapemode
                        ? 70
                        : isbuttonVisible
                        ? 110
                        : 0,
                  },
                  android: {
                     marginBottom: isLandscapemode
                        ? 14
                        : isbuttonVisible
                        ? 4
                        : 0,
                  },
               }),
            }}>
            <FlatList
               style={{
                  ...Platform.select({
                     web: {
                        backgroundColor: appBackgroundWhiteBG,
                     },
                  }),
               }}
               data={props.myTraningList}
               renderItem={(item, index) => {
                  return props.listType === TRAINING ? (
                     <ModuleItems key={index} props={item} />
                  ) : (
                     <DocumentItems
                        item={item}
                        onRowClick={() => {
                           props.onDownloadPress(
                              'GetDocument',
                              item.item.RecordKey,
                              item.item.FileName,
                           );
                        }}
                     />
                  );
               }}
               numColumns={1}
            />
         </View>
      </ContainerWrapper>
   );
};

const styles = StyleSheet.create({
   container: {
      backgroundColor: appBackgroundWhiteBG,
      flex: 1,
   },
   headerTopBackground: {
      backgroundColor: '#003DA6',
      paddingHorizontal: 16,
      paddingVertical: 16,
      flexDirection: 'row',
      alignItems: 'center',
   },
   headerBottomBackground2: {
      backgroundColor: '#000000',
      paddingHorizontal: 16,
      paddingVertical: 6,
      flexDirection: 'row',
      alignItems: 'center',
      minHeight: 40,
   },
   headerBottomBackground: {
      backgroundColor: primaryColor900,
      paddingStart: 16,
      paddingVertical: 10,
      flexDirection: 'row',
      alignItems: 'center',
   },
});

export default RecordDetailsScreen;
